import classNames from 'classnames';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import { ImgHeightProps, ThemeWBProps } from 'eco-design-micro/props/const';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import { TitleDescProps } from 'eco-design-micro/props/msg/TitleDescProps';
import EcoImg from 'eco-design/base/eco-img';
import React, { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import './index.scss';

export interface EcoStoriesItemProps extends ImgVideoProps, TitleDescProps {
    /**
     * 左上角标
     */
    icon?: string;
    /**
     * stories内容
     */
    desc?: string;
    /**
     * 用户头像
     */
    user?: string;
    /**
     * 用户名 1
     */
    userName?: string;
    /**
     * 用户信息 2
     */
    userName2?: string;
}

export interface EcoUserStoriesCardProps {
    /**
     * 布局方式
     */
    layout?: 'default' | 'h5-scroll';
    /**
     * 布局方式-卡片
     *
     * img-top 图片在上
     *
     * img-bottom 图片在下
     */
    cardLayout?: 'img-top' | 'img-bottom';
    /**
     * 主题色
     */
    theme?: ThemeWBProps; // 主题色
    /**
     * 列表
     */
    items: EcoStoriesItemProps[]; // item
    /**
     * 图片容器高度
     *
     * 5-3
     *
     * 1-1
     *
     * 4-3
     *
     * 16-9
     */
    imgHeight?: ImgHeightProps;
    /**
     * 样式名
     */
    className?: string;

    onClickNavigation?: (direction: 'prev' | 'next') => void;
}

// 默认用户头像
const defaultUserIcon = 'https://websiteoss.ecoflow.com/upload/image/1735782674645/logo.svg';
/**
 * 博客列表(标题 + 描述)
 */
const EcoUserStoriesCard: React.FC<EcoUserStoriesCardProps> = ({
    imgHeight = '1-1',
    layout = 'default',
    cardLayout = 'img-top',
    theme = 'white',
    items = [],
    className,
    onClickNavigation,
}) => {
    const prefixCls = `eco-stories-card`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-layout-${layout}`]: layout,
        [`${prefixCls}-layout-card-${cardLayout}`]: cardLayout,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-length-${items.length}`]: items.length,
        [`${prefixCls}-imgHeight-${imgHeight}`]: imgHeight,
    });
    const [spaceBetweenN, setSpaceBetweenN] = useState(24);
    useEffect(() => {
        const initHandle = () => {
            const clientWidth = document.body.clientWidth;
            if (clientWidth >= 1024) {
                setSpaceBetweenN(24);
            } else {
                setSpaceBetweenN(16);
            }
        };
        initHandle();
    }, []);
    return (
        <div className={classes}>
            <div className={`${prefixCls}-container`}>
                <Swiper
                    slidesPerView={'auto'}
                    spaceBetween={spaceBetweenN}
                    navigation={{
                        nextEl: '.eco-swiper-button-next',
                        prevEl: '.eco-swiper-button-prev',
                    }}
                    modules={[Navigation]}
                >
                    {items.map((stories: EcoStoriesItemProps, index: number) => {
                        return (
                            <SwiperSlide key={index} className={`${prefixCls}-item`}>
                                <div className={`${prefixCls}-item-header`}>
                                    <div className={`${prefixCls}-item-icon`}>
                                        <EcoImg pc={stories.icon} />
                                    </div>
                                    <p className={`${prefixCls}-item-desc`}>{stories.desc}</p>
                                </div>
                                <div className={`${prefixCls}-item-img`}>
                                    <EcoImg pc={stories.pc} />
                                </div>
                                <div className={`${prefixCls}-item-footer`}>
                                    <div className={`${prefixCls}-item-user`}>
                                        <EcoImg pc={stories.user || defaultUserIcon} />
                                    </div>
                                    <div className={`${prefixCls}-item-name`}>
                                        <p>{stories.userName}</p>
                                        <p>{stories.userName2}</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                    <div className={`eco-swiper-control eco-swiper-control-${theme}`}>
                        <div className="eco-swiper-navigation">
                            <div className="eco-swiper-button-prev" onClick={() => onClickNavigation?.('prev')}>
                                <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                            </div>
                            <div className="eco-swiper-button-next" onClick={() => onClickNavigation?.('next')}>
                                <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                            </div>
                        </div>
                    </div>
                </Swiper>
            </div>
        </div>
    );
};

export default EcoUserStoriesCard;
